// src/components/layouts/sharedComponents/StyledComponents.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import styled from '@emotion/styled';
import React from 'react';
import { DARK_MODE } from 'constants/ThemeConstant';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const LIGHT_BG = '#ffffff';
const LIGHT_BG_TRANSLUCID = 'rgba(250, 250, 251, 0.6)';
const DARK_BG = DARK_MODE.BG_COLOR;
const DARK_BG_TRANSLUCID = 'rgba(40, 49, 66, 0.6)';

const LIGHT_TEXT_COLOR = 'rgba(0, 0, 0, 0.65)';
const DARK_TEXT_COLOR = DARK_MODE.TEXT_COLOR;

// *******************************************************************************
// STYLED COMPONENTS
// *******************************************************************************
const Wrapper = styled('div')(
  ({ translucid, isDark, customZIndex, customPosition, customBorderRadius, customTop, style = {} }) => ({
    zIndex: customZIndex ?? 0,
    position: customPosition ?? 'fixed',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: isDark
      ? translucid
        ? DARK_BG_TRANSLUCID
        : DARK_BG
      : translucid
        ? LIGHT_BG_TRANSLUCID
        : LIGHT_BG,
    borderRadius: customBorderRadius ?? 0,
    top: customTop ?? 0,
    // pointerEvents: 'none',
    ...style,
  })
);

const Content = styled('div')(({ style = {} }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 12,
  ...style,
}));

const Title = styled('div')(({ isDark, style = {} }) => ({
  fontSize: 14,
  lineHeight: 1.2,
  color: isDark ? DARK_TEXT_COLOR : LIGHT_TEXT_COLOR,
  textAlign: 'center',
  userSelect: 'none',
  ...style,
}));

// *******************************************************************************
// EXPORTS
// *******************************************************************************
export const StyledCover = ({ children, currentTheme, ...props }) => {
  const isDark = currentTheme === 'dark';
  return (
    <Wrapper isDark={isDark} {...props}>
      {children}
    </Wrapper>
  );
};

export const StyledContentCenter = ({ children, ...props }) => {
  return <Content {...props}>{children}</Content>;
};

export const StyledTitleCenter = ({ children, currentTheme, ...props }) => {
  const isDark = currentTheme === 'dark';
  return (
    <Title isDark={isDark} {...props}>
      {children}
    </Title>
  );
};
